// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b9891b99","495":"b47b028b","580":"a5fe7756","989":"430e8ab8"}[chunkId] + ".chunk.js";
};